import type { FetchDietitianInvoicesParams } from "@client/clinic/fetchDietitianInvoices";

export const dietitianKeys = {
  base: () => ["dietitian"],
  plans: () => [...dietitianKeys.base(), "plans"],
  currentSubscription: () => [
    ...dietitianKeys.base(),
    "subscription",
    "current",
  ],
  availableSubscriptionAddons: () => [
    ...dietitianKeys.currentSubscription(),
    "available-addons",
  ],
  invoices: (params?: FetchDietitianInvoicesParams) => [
    ...dietitianKeys.base(),
    "invoices",
    params?.unpaid ?? "all",
    params?.page ?? 1,
    params?.perPage ?? 15,
  ],
  subscriptionCoupons: () => [
    ...dietitianKeys.base(),
    "subscription",
    "coupons",
  ],
  subscriptionCancellationReasons: () => [
    ...dietitianKeys.base(),
    "subscription",
    "cancellation-reasons",
  ],
  unpaidInvoicesCount: () => [
    ...dietitianKeys.base(),
    "invoices",
    "unpaid-count",
  ],
};
